import axios from 'axios'

// Type our custom configuration options for axios
declare module 'axios' {
    export interface AxiosRequestConfig {
        useGlobalErrorHandler?: boolean
    }
}

const StoreApiAxios = axios.create()

export default StoreApiAxios
